import Transform from './Base';
import store from '@/store';

const formatTeam = team => {
  if (!team) {
    return {
      id: -1,
      team_name: '',
    };
  }

  const { _id, ...options } = team;
  return {
    ...options,
    id: _id,
  }
};

export const getReviewColor = status => {
  return status ? '#9bc225' : '#d4d4d4';
};

export default class TracksMappingTransform extends Transform {
  /**
   * Method used to transform fetched tracks mapping.
   *
   * @param track The fetched job.
   *
   * @returns {Object} The transformed job.
   */
  static fetch(track, index) {
    const number = track?.player?.player_number;
    const intervalMain = {
      interpolated: false,
      start: track.frame_first,
      length: track.frame_last - track.frame_first,
    };
    const interpolated = track?.interpolated_intervals?.map(([start, end]) => ({
      interpolated: true,
      start,
      length: end - start,
    })) || [];

    try {
      return {
        color: getReviewColor(track.review_status),
        frame_first: track.frame_first,
        frame_last: track.frame_last,
        id: `${track.track_id}-${index}`,
        job_id: track.job_id,
        team_id: track.team_id,
        track_id: track.track_id,
        intervals: [ intervalMain, ...interpolated ],
        player: {
          id: track?.player?._id || null,
          player_name: track?.player?.player_name || '',
          player_number: number && number !== -1 ? number : '',
        },
        points: track.points || [],
        review_status: track.review_status || false,
        team: formatTeam(track.team),
      };
    } catch (e) {
      return null;
    }
  }

  static canonicalPoints(points) {
    try {
      return points.map(({ x_rel, y_rel }) => ({
        x: x_rel,
        y: y_rel,
      }));
    } catch(e) {
      return points;
    }
  }

  static updateItem(oldEl, newEl) {
    const { team, player, review_status, team_id } = newEl;
    const number = player?.player_number;

    try {
      return {
        ...oldEl,
        color: getReviewColor(review_status),
        player: {
          ...oldEl.player,
          player_name: player?.player_name || '',
          player_number: number && number !== -1 ? number : '',
        },
        review_status,
        team: formatTeam(team),
        team_id,
      };
    } catch(e) {
      console.log(e);
      return oldEl;
    }
  }
}
